import md5 from 'md5';
import humanFormat from 'human-format';
import i18n from './i18n.js';

const { __, _n, sprintf } = wp.i18n;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-Editor-';

let InstabergUtils = {};

InstabergUtils.isset = function( arr, var_args ) {
  for (let i=1, k=arguments.length; i<k; ++i) {
    if ( !arr || !arr.hasOwnProperty(arguments[i]) ) {
      return false;
    }
    arr = arr[arguments[i]];
  }
  return true;
}

InstabergUtils.logo = function() {
    return <img src={ `${INSTABERG_VARS.assets_url}/images/logo.png` } />
};

InstabergUtils.colors = function() {

    let original_colors = [
      { name: 'light-grayish-magenta', hex: '#d0a5db' },
      { name: 'pale-pink', hex: '#f78da7' },
      { name: 'vivid-red', hex: '#cf2e2e' },
      { name: 'luminous-vivid-amber', hex: '#fcb900' },
      { name: 'vivid-cyan-blue', hex: '#0693e3' },
      { name: 'vivid-cyan-turquoise', hex: '#00BCD4' },
      { name: 'vivid-cyan-green', hex: '#00C853' },
      { name: 'very-light-gray', hex: '#eee' },
      { name: 'vivid-white', hex: '#fff' },
      { name: 'very-dark-gray', hex: '#444' },
      { name: 'very-dark-blue', hex: '#37474F' },
    ];

    let return_colors = [];
    original_colors.forEach( (color) => {
      return_colors.push({
        'name': color.name,
        'color': color.hex,
        'slug': color.name.toLowerCase()
      })
    });
    return return_colors;
}

InstabergUtils.loader = function( size ) {
  return ([
  <div className={ `${alias}spinner` }>
    <svg width={ size } height={ size } viewBox={ "0 0 " + size + " " + size } xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(2 1)" stroke="#FFF" stroke-width="1.5">
              <circle cx="42.601" cy="11.462" r="5" fill-opacity="1" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="1;0;0;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="49.063" cy="27.063" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;1;0;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="42.601" cy="42.663" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;1;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="27" cy="49.125" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;1;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="11.399" cy="42.663" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;1;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="4.938" cy="27.063" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;1;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="11.399" cy="11.462" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;0;1;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="27" cy="5" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;0;0;1" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
          </g>
      </g>
      </svg>
    </div>
  ]);
}

InstabergUtils.galleryImageDefault = function() {
  return (
    <div className={ `${alias}gallery-default-image` }></div>
  );
}

InstabergUtils.itemShowIcon = function( post_type ) {
  return (
    'video' === post_type ? <i class="mi-icon mi-icon-video-camera4"></i> : ''
  );
}

InstabergUtils.Video_In_List = function( list, video ) {

  let found = false;
  list.map( (item) => {

    if ( item.id === video.id ) {
      found = true;
    }
  });
  return found;
}

InstabergUtils.Video_In_List_GetKey = function( list, video ) {

  let found = false;
  list.map( (item, idx) => {

    if ( item.id === video.id ) {
      found = idx;
    }
  });
  return found;
}

InstabergUtils.get_video_details = function( list, video_id ) {

  let found = false;
  list.map( (item) => {

    if ( item.id === video_id ) {
      found = item;
    }
  });
  return found;
}

InstabergUtils.mapOrder = function( array, order, key ) {

  array.sort( function (a, b) {
    var A = a[key], B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }

  });

  return array;
};

InstabergUtils.capitalize = (s) => {
  if ( typeof s !== 'string' ) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

InstabergUtils.isFunction = function(item) {
  if (typeof item === 'function') {
    return true;
  }
  var type = Object.prototype.toString.call(item);
  return type === '[object Function]' || type === '[object GeneratorFunction]';
}

InstabergUtils.isEmpty = function(input) {
  if (typeof input === 'array') {
    return input.length === 0;
  }
  return !input || Object.keys(input).length === 0;
}

InstabergUtils.range = function(start, stop, step=1) {
  const range = Array( Math.ceil((stop - start) / step) + 1 ).fill(start).map( (x, y) => x + y * step );
  return range;
}

InstabergUtils.getViewComponentKey = function( options, videos ) {
  let viewKey = null;
  viewKey += JSON.stringify( videos );
  viewKey += JSON.stringify( options );
  return md5( viewKey );
}

InstabergUtils.humanFormat = function( number ) {
  return humanFormat( number, {
    decimals: 1,
    separator: '',
  });
}

InstabergUtils.text_truncate = function(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

InstabergUtils.makeid = function( length=10 ) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

InstabergUtils.galleryType = function() {
  return [
    { label: 'images', value: 'images' },
    { label: 'videos', value: 'videos' },
    { label: 'all', value: 'all' },
  ];
}

InstabergUtils.GoogleFontLoader = function ( font ) {
  let fetchStyle = function(url) {
    return new Promise((resolve, reject) => {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function() {
        resolve();
      };
      link.href = url;

      let headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);
    });
  };

  if (font == 'Theme Default') return false;
  if (font == 'Arial') return false;

  if (!INSTABERG_VARS.fonts.includes(font)) {
    fetchStyle(`https://fonts.googleapis.com/css?family=` + font.replace(' ', '+'));
    INSTABERG_VARS.fonts.push(font);
  }
}

export default InstabergUtils;



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/misc/utils.js